var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8501 12.1289H12.7001",
    stroke: "#24A95D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.775 1.40386C10.0336 1.14527 10.3843 1 10.75 1C10.9311 1 11.1104 1.03567 11.2777 1.10496C11.445 1.17425 11.597 1.27582 11.725 1.40386C11.853 1.5319 11.9546 1.6839 12.0239 1.85119C12.0932 2.01848 12.1289 2.19778 12.1289 2.37886C12.1289 2.55993 12.0932 2.73923 12.0239 2.90652C11.9546 3.07382 11.853 3.22582 11.725 3.35386L3.6 11.4789L1 12.1289L1.65 9.52886L9.775 1.40386Z",
    stroke: "#24A95D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGroup);
export default __webpack_public_path__ + "static/media/editGroup.0daadfa4dea533c3c3a6434bda787512.svg";
export { ForwardRef as ReactComponent };